"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notify = exports.notifyWarning = exports.notifyError = exports.renderNotify = exports.dismissNotify = void 0;
const react_1 = __importStar(require("react"));
const react_toastify_1 = require("react-toastify");
const classnames_1 = __importDefault(require("classnames"));
const utils_1 = require("../../utils/utils");
const html_parser_1 = __importDefault(require("../html-parser/html-parser"));
const line_progress_bar_1 = __importDefault(require("../line-progress-bar/line-progress-bar"));
require("react-toastify/dist/ReactToastify.css");
require("../../styles/components/notify.less");
const NotifyContent = ({ icon, notifyMsgObj, addedContent, notificationIcon }) => (react_1.default.createElement("div", { className: "text-holder" },
    notificationIcon || (0, utils_1.resolveIconString)(icon, 'icon'),
    react_1.default.createElement("div", { className: "body" },
        react_1.default.createElement("div", { className: "title" }, notifyMsgObj.title || ''),
        react_1.default.createElement("div", { className: "text-wrapper" },
            react_1.default.createElement("div", { className: "text" },
                react_1.default.createElement(html_parser_1.default, { html: notifyMsgObj.text, breakLine: true })),
            addedContent))));
const dismissNotify = (toastId) => {
    react_toastify_1.toast.dismiss(toastId);
};
exports.dismissNotify = dismissNotify;
const renderNotify = ({ class_name: notifyClass, ...notifyMsgObj }) => {
    if (notifyMsgObj === undefined) {
        return null;
    }
    const isProgress = notifyClass === 'progress';
    const { sticky = isProgress, onClose, draggable, closeOnClick = !isProgress, notificationIcon, shouldUpdate = isProgress, toastId, closeText = 'DISMISS', icon, progress, } = notifyMsgObj;
    let { addedContent } = notifyMsgObj;
    let newToastId = toastId;
    const dismiss = () => {
        (0, exports.dismissNotify)(newToastId);
    };
    const CloseButton = () => (react_1.default.createElement("span", { onClick: dismiss, className: "toast-notify-close-button" }, closeText));
    const autoClose = sticky ? false : notifyMsgObj.autoClose || 3000;
    let notifyType;
    let defaultIcon;
    switch (notifyClass) {
        case 'error':
        case 'danger':
            notifyType = 'error';
            defaultIcon = 'fa-exclamation-triangle';
            break;
        case 'invite':
            notifyType = 'success';
            defaultIcon = 'fa-paper-plane-o';
            break;
        case 'warning':
            notifyType = 'warning';
            defaultIcon = 'fa-exclamation-triangle';
            break;
        case 'progress':
            notifyType = 'success';
            addedContent = react_1.default.createElement(line_progress_bar_1.default, { progress: progress, className: "notify-progress-bar" });
            break;
        default:
            notifyType = 'success';
            defaultIcon = 'fa-check-circle';
            break;
    }
    const options = {
        type: notifyType,
        containerId: 'A',
        bodyClassName: 'toast-notify-body',
        toastClassName: 'toast-notify',
        className: (0, classnames_1.default)('toast-notify-container', notifyType, notifyMsgObj.className, {
            'progress-bar-container': isProgress,
        }),
        closeButton: notifyMsgObj.disableDismiss ? false : react_1.default.createElement(CloseButton, null),
        onClose,
        draggable,
        closeOnClick,
        autoClose,
    };
    const content = (react_1.default.createElement(NotifyContent, { icon: icon || defaultIcon, notificationIcon: notificationIcon, notifyMsgObj: notifyMsgObj, addedContent: addedContent }));
    if (shouldUpdate && toastId) {
        return react_toastify_1.toast.update(toastId, { ...options, render: content });
    }
    newToastId = (0, react_toastify_1.toast)(content, { ...options, toastId });
    return newToastId;
};
exports.renderNotify = renderNotify;
const notifyError = (message, title = '') => (0, exports.renderNotify)({
    title,
    text: message,
    class_name: 'error',
});
exports.notifyError = notifyError;
const notifyWarning = (message, title = '', autoClose = 12000) => (0, exports.renderNotify)({
    title,
    text: message,
    class_name: 'warning',
    autoClose,
});
exports.notifyWarning = notifyWarning;
class Notify extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.toastId = null;
    }
    componentDidMount() {
        const { notificationOpen, toastId, notifyMsgObj } = this.props;
        if (notifyMsgObj && (notificationOpen === undefined || notificationOpen)) {
            this.createToast(toastId);
        }
    }
    componentDidUpdate() {
        const { toastId, notificationOpen } = this.props;
        if (toastId && react_toastify_1.toast.isActive(toastId)) {
            this.modifyToast(toastId);
        }
        else if (notificationOpen === undefined || notificationOpen) {
            this.createToast(toastId);
        }
    }
    componentWillUnmount() {
        if (this.toastId) {
            react_toastify_1.toast.dismiss(this.toastId);
        }
    }
    createToast(toastId) {
        const { notifyMsgObj, addedContent, disableDismiss, icon, className, onClose, draggable = true, closeOnClick = true, ...moreProps } = this.props;
        this.toastId = (0, exports.renderNotify)({
            addedContent,
            disableDismiss,
            notificationIcon: icon,
            className,
            toastId,
            onClose,
            shouldUpdate: false,
            draggable,
            closeOnClick,
            ...moreProps,
            ...notifyMsgObj,
        });
    }
    modifyToast(toastId) {
        const { notifyMsgObj, addedContent, disableDismiss, icon, className, onClose, draggable = true, closeOnClick = true, ...moreProps } = this.props;
        (0, exports.renderNotify)({
            addedContent,
            disableDismiss,
            notificationIcon: icon,
            className,
            toastId,
            onClose,
            shouldUpdate: true,
            draggable,
            closeOnClick,
            ...moreProps,
            ...notifyMsgObj,
        });
    }
    render() {
        return null;
    }
}
exports.Notify = Notify;
// Todo add this when convert the Notify to function components
// Notify.defaultProps = {
// 	className: undefined,
// 	class_name: undefined,
// 	sticky: undefined,
// 	onClose: undefined,
// 	draggable: undefined,
// 	closeOnClick: undefined,
// 	notificationIcon: undefined,
// 	shouldUpdate: undefined,
// 	toastId: undefined,
// 	closeText: undefined,
// 	icon: undefined,
// 	progress: undefined,
// 	addedContent: undefined,
// 	autoClose: undefined,
// 	disableDismiss: undefined,
// };
// Notify.propTypes = {
// 	className: PropTypes.string,
// 	class_name: PropTypes.oneOf(['success', 'invite', 'progress', 'error', 'danger']),
// 	sticky: PropTypes.bool,
// 	onClose: PropTypes.func,
// 	draggable: PropTypes.bool,
// 	closeOnClick: PropTypes.func,
// 	notificationIcon: PropTypes.element,
// 	shouldUpdate: PropTypes.bool,
// 	toastId: PropTypes.string,
// 	closeText: PropTypes.func,
// 	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
// 	progress: PropTypes.number,
// 	addedContent: PropTypes.element,
// 	autoClose: PropTypes.bool,
// 	disableDismiss: PropTypes.bool,
// };
//# sourceMappingURL=notify.js.map